import { render } from "./bind_device.vue?vue&type=template&id=057c6a89"
import script from "./bind_device.vue?vue&type=script&lang=js"
export * from "./bind_device.vue?vue&type=script&lang=js"

import exportComponent from "E:\\newwww\\shared_space\\shared_store\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__